import { render, staticRenderFns } from "./DetailServiceMaster.vue?vue&type=template&id=2f3b88f8&scoped=true"
import script from "./DetailServiceMaster.vue?vue&type=script&lang=js"
export * from "./DetailServiceMaster.vue?vue&type=script&lang=js"
import style0 from "./DetailServiceMaster.vue?vue&type=style&index=0&id=2f3b88f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b88f8",
  null
  
)

export default component.exports